import {
  RECEIVE_MARKUP,
  RECEIVING_MARKUP,
  RECEIVE_MARKUP_METADATA,
  SAVING_MARKUP,
  UPDATING_MARKUP,
  DELETE_MARKUP,
  DELETING_MARKUP,
  RESET_MARKUP_META,
  CLEAR_MARKUP_STATE,
  CLEAR_STATE,
  INCREMENT_MARKUP_COUNT,
  SET_ALL_MARKUP_LOADED
} from '@/store/mutationTypes'
import {
  receiveData,
  deleteData,
  increment,
  receiveMetadata,
  resetMetadata,
  clearLocalState,
  clearState
} from '@/store/modules/helpers/mutationHelpers'

const state = {
  data: {},
  cache: {},
  count: null,
  shown: null,
  currentPage: 1,
  saving: false,
  receivingData: false,
  updating: null,
  deleting: false,
  allMarkupLoaded: false
}

const actions = {
  setMarkupPreloadStatus (store, payload) {
    this.commit(SET_ALL_MARKUP_LOADED, payload)
  },
  clearMarkupState (store, clearCache = false) {
    this.commit(CLEAR_MARKUP_STATE, clearCache)
  }
}

const getters = {
  getMarkup: (state) => {
    return state.data ? Object.values(state.data).map(v => Object.assign({}, v)) : []
  },
  getAllMarkup: (state) => {
    return state.cache ? Object.values(state.cache).map(v => Object.assign({}, v)) : []
  },
  getMarkupMetadata: (state) => {
    const { shown, count } = state
    if (!shown) return { count: 0, shown: 0 }
    return { count, shown }
  },
  getMarkupById: (state, rootState) => (id) => {
    if (state.data && state.data[id]) {
      return state.data[id]
    } else if (state.cache && state.cache[id]) {
      return state.cache[id]
    } else {
      return {}
    }
  },
  getDefaultMarkup: (state) => {
    return Object.values(state.cache).find(v => v.active) || {}
  },
  getMarkupFetchStatus: (state) => {
    return state.receivingData
  },
  getMarkupSaveStatus: (state) => {
    return state.saving
  },
  getMarkupUpdateStatus: (state) => {
    return state.updating
  },
  getMarkupDeleteStatus: (state) => {
    return state.deleting
  }
}

const mutations = {
  [RECEIVE_MARKUP] (state, results) {
    receiveData(state, results)
  },
  [RECEIVING_MARKUP] (state, payload) {
    state.receivingData = payload
  },
  [SAVING_MARKUP] (state, payload) {
    state.saving = payload
  },
  [UPDATING_MARKUP] (state, payload) {
    state.updating = payload
  },
  [DELETE_MARKUP] (state, payload) {
    deleteData(state, payload)
  },
  [DELETING_MARKUP] (state, payload) {
    state.deleting = payload
  },
  [INCREMENT_MARKUP_COUNT] (state, payload) {
    increment(state, payload)
  },
  [RECEIVE_MARKUP_METADATA] (state, payload) {
    receiveMetadata(state, payload)
  },
  [CLEAR_MARKUP_STATE] (state, payload) {
    clearLocalState(state, payload)
  },
  [RESET_MARKUP_META] (state) {
    resetMetadata(state)
  },
  [CLEAR_STATE] (state) {
    clearState(state)
  },
  [SET_ALL_MARKUP_LOADED] (state, payload) {
    state.allMarkupLoaded = payload
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}
